import { useMemo } from "react";
import { useBookingRequest } from "../../../../api/grpc/booking/useBookingRequest";
import { useTimeZoneContext } from "../../../../lib/context/TimeZone/TimeZoneContext";
import useGrpcQuery, {
  GrpcQueryOptions,
} from "../../../../lib/hooks/useGrpcQuery";

import {
  PaginatedListPersonalMeetingsRequest,
  PaginatedListPersonalMeetingsResponse,
} from "../../../../api/grpc/booking/booking";

export const useRoomReservations = () => {
  const { listBookings } = useBookingRequest();
  const { timeZone } = useTimeZoneContext();

  const listAllBookings = async (
    variables: PaginatedListPersonalMeetingsRequest,
    options?: GrpcQueryOptions
  ) => {
    let result = await listBookings(variables, options);
    const days = [...result.response.days];

    // An empty page can still have a token when the server stopped scanning early.
    while (result.response.nextPageToken) {
      result = await listBookings(
        { ...variables, pageToken: result.response.nextPageToken },
        options
      );
      days.push(...result.response.days);
    }

    return { ...result, response: { ...result.response, days } };
  };

  const {
    loading: loadingRoom,
    error: errorRoom,
    data,
    refetch: refetchRoom,
  } = useGrpcQuery<
    PaginatedListPersonalMeetingsRequest,
    PaginatedListPersonalMeetingsResponse
  >({
    method: listAllBookings,
    variables: {
      customerId: "",
      pageDays: 7,
      pageToken: "",
      timeZone: timeZone,
    },
    refetchOnWindowFocus: true,
    refetchOnWindowFocusThreshold: 30000,
  });

  const roomData = useMemo(
    () => data && { meetings: data.days.flatMap((day) => day.meetings) },
    [data]
  );

  return {
    loadingRoom,
    errorRoom,
    roomData,
    refetchRoom,
  };
};
